<template>
  <el-container class="main-container">
    <div class="content-wrapper">
      <div class="product-container">
        <div class="nav-button-container">
          <el-button icon="el-icon-arrow-right" @click="initNextProductInfo" class="nav-button left"></el-button>
        </div>

        <!-- 左侧文字区域 -->
        <div class="product-info">
          <h1 class="product-name">{{ productInfo.productName }}</h1>
          <p class="product-remark">{{ productInfo.productRemark }}</p>
          <div class="product-description" v-html="productInfo.productJieshao"></div>
          <el-button class="quote-button" style="background-color: #33689A" type="primary" @click="showPrice">{{ t('getQuote') }}</el-button>
          <div class="resource-link">
            <span class="link-title">{{ t('resourceLink') }}:</span>
            <span class="link-catalog">
              <router-link :to="{ name: 'ProductSearch', params: { type: modelType } }" class="a-style">{{ t('catalog') }}</router-link>
            </span>
          </div>
        </div>

        <!-- 右侧图片区域 -->
        <div class="product-gallery">
          <div class="gallery-main">
            <el-button icon="el-icon-arrow-left" @click="prevImage" class="nav-button left"></el-button>
            <img :src="images[currentIndex]" class="main-image" />
            <el-button icon="el-icon-arrow-right" @click="nextImage" class="nav-button right"></el-button>
          </div>

          <div class="gallery-thumbs">
            <div
                v-for="(img, index) in images"
                :key="index"
                class="thumb"
                :class="{ active: currentIndex === index }"
                @click="currentIndex = index"
            >
              <img :src="img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import {getProduct, getNextInfo} from "@/utils/http";

export default {
  name: "productInfo",
  props: ['t', 'currentLang'],
  data() {
    return {
      currentLang: 'zh',
      images: [
        '/static/pic1.png',
        '/static/pic2.png',
        '/static/pic3.png',
        '/static/pic4.png'
      ],
      currentIndex: 0,
      productId:0,
      productInfo:{},
      modelType:0,
      price:0
    };
  },
  mounted() {
    this.productId = this.$route.params.id;
    this.modelType = this.$route.params.modelType;
    this.initProductInfo();
  },
  methods: {
    showPrice() {
      this.$alert("产品价格:【￥"+this.price+"】", this.t('priceTitle'), {
        confirmButtonText: this.t('confirm')
      });
    },
    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    initProductInfo(){
      getProduct(this.productId).then(response => {
        this.productInfo = response.data;
        this.images = this.productInfo.picUrl.split(",");
        this.price = this.productInfo.price;
      })
    },
    initNextProductInfo() {
      const param = {
        id: this.productId,
        type: this.modelType
      }
      getNextInfo(param).then(response => {
        this.productInfo = response.data;
        this.images = this.productInfo.picUrl.split(",");
        this.price = this.productInfo.price;
      })
    },
  }
};
</script>

<style scoped>
/* 基础样式 */
section, div, img {
  margin: 0;
  padding: 0;
}

.a-style {
  text-decoration: none;
  color: inherit;
}

img {
  display: block;
  max-width: 100%;
}

.main-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  background-color: #FFFFFF;
}

.content-wrapper {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 20px;
}

.product-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.nav-button-container {
  width: 5%;
}

.nav-button {
  position: absolute;
  top: 120px;
  left: 50px;
  background: rgba(255, 255, 255, 0.7);
  padding: 5px;
}

.product-info {
  width: 45%;
  color: #000000;
  padding-right: 50px;
}

.product-name {
  font-size: 40px;
  margin-bottom: 20px;
}

.product-remark {
  font-size: 16px;
  margin-bottom: 20px;
}

.product-description {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.quote-button {
  margin-top: 20px;
}

.resource-link {
  margin-top: 30px;
}

.link-title {
  font-weight: bold;
  font-size: 14px;
}

.link-catalog {
  font-size: 14px;
  color: #4F7DA8;
  margin-left: 20px;
}

.product-gallery {
  width: 50%;
}

.gallery-main {
  position: relative;
  text-align: center;
}

.main-image {
  width: 100%;
  height: auto;
  max-height: 500px;
  object-fit: contain;
}

.gallery-thumbs {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  flex-wrap: wrap;
}

.thumb {
  border: 2px solid transparent;
  margin: 0 5px;
  cursor: pointer;
}

.thumb.active {
  border-color: #409EFF;
}

.thumb img {
  width: 80px;
  height: auto;
}

/* 高分辨率适配 */
@media screen and (min-width: 1921px) {
  .content-wrapper {
    max-width: 1920px;
  }

  .product-container {
    max-width: 1600px;
  }
}

/* 纯移动端样式 - 只在小于768px时生效 */
@media screen and (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  .product-container {
    flex-direction: column;
  }

  .nav-button-container {
    display: none;
  }

  .product-info,
  .product-gallery {
    width: 100%;
    padding-right: 0;
  }

  .product-gallery {
    margin-top: 30px;
  }

  .product-name {
    font-size: 28px;
  }

  .gallery-main {
    margin-bottom: 15px;
  }

  .nav-button.left {
    left: 10px;
  }

  .nav-button.right {
    right: 10px;
  }

  .thumb img {
    width: 50px;
  }
}

/* 小屏幕手机调整 */
@media screen and (max-width: 480px) {
  .product-name {
    font-size: 24px;
  }

  .product-remark,
  .product-description {
    font-size: 14px;
  }

  .gallery-thumbs {
    justify-content: flex-start;
    overflow-x: auto;
    padding-bottom: 10px;
  }

  .thumb {
    margin: 0 3px;
  }

  .thumb img {
    width: 40px;
  }
}
</style>
